// (2026-07-02) SENIAT Fase 1: página de la sección "Catálogos SENIAT"
// (solo admin/auditor). Misma estructura que las demás páginas de
// Configuración (p. ej. ListTaxes / ListPaymentMethods).
import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import CatalogosSeniat from "../../components/Config/CatalogosSeniat";
import AdminLayout from "../../layouts/AdminLayout";

export default function CatalogosSeniatPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";

  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      {/* Contenedor principal con separación y fondo blanco */}
      <div className="mt-8 px-4 md:px-8">
        <CatalogosSeniat />
      </div>
    </AdminLayout>
  );
}
